export function initStickyHeader() {
    const headerElement = document.querySelector('header');
    if (!headerElement) return;

    let lastScrollTop = 0;
    const threshold = 10;

    window.addEventListener('scroll', () => {
        const scrollTop = document.scrollingElement.scrollTop; // modern way
        const delta = scrollTop - lastScrollTop;
        const height = headerElement.offsetHeight;

        if (Math.abs(delta) > threshold) {
            if (delta > 0 && scrollTop > height) {
                headerElement.classList.add('slide-out');
            } else if (delta < 0) {
                headerElement.classList.remove('slide-out');
            }
        }

        lastScrollTop = scrollTop;
    });
}